export const environment = {
    NAME: "root",
    API_LOCATION: 'http://tpdevpsifarm:8089/api',
  };
  